import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { meApi } from '../api/endpoints/me';

export type MyProfile = Awaited<ReturnType<typeof meApi.getProfile>>;

export const MY_PROFILE_QUERY_KEY = ['me', 'profile'] as const;
const MY_PROFILE_STALE_TIME_MS = 5 * 60_000;

/** Única lectura de `/me/profile` en la consola; cada consumidor proyecta lo suyo con `select`. */
export function useMyProfile<T = MyProfile>(select?: (profile: MyProfile) => T): UseQueryResult<T> {
    return useQuery({
        queryKey: MY_PROFILE_QUERY_KEY,
        queryFn: () => meApi.getProfile(),
        staleTime: MY_PROFILE_STALE_TIME_MS,
        select,
    });
}
